import { Box, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '输注新鲜血液或血液制品的最常见反应是：',
  '发烧',
  '皮疹、瘙痒和荨麻疹',
  '感觉有点不适',
  '罕见的风险包括：',
  '输注过多的血液/液体导致呼吸短促。',
  '溶血，即红细胞的异常分解。',
  '抗体的产生可能会使未来的输血变得复杂。如果这些并发症发生在女性身上，可能会对当前和未来的未出生婴儿造成问题。',
  '肺损伤导致呼吸短促。',
  '病毒或其他感染性病菌通过献血者的血液传播。',
  '极少数情况下，上述反应可能会导致严重伤害甚至死亡。',
  '长期多次输血会有一些特定的问题，可能与您的病情有关。（您的医生会与您讨论这些问题）',
];

const CContents = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="C. 血液和/或血液製品輸血的風險" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{ fontWeight: '500', fontSize: '15px', lineHeight: '24px' }}
              >
                {v}
              </Typography>
            );
          }
          if (i === 1 || i === 5) {
            return (
              <Typography
                sx={{ fontWeight: '400', fontSize: '15px', lineHeight: '24px' }}
              >
                <p />
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default CContents;
